<template>
  <v-container fluid class="home">
    <!--    <img alt="Vue logo" src="../assets/logo.png" />-->
    <h1>Home</h1>
    <p>Select <strong>Browse</strong> to the left. If you have not registered or logged in, do that first.</p>
    <!-- Check that the SDK client is not currently loading before accessing is methods -->
    <div v-if="user.user">
      <v-avatar v-if="user.user.picture"><img :src="user.user.picture"/></v-avatar>
      <h2>{{ user.user.name }}</h2>
      <p>{{ user.user.email }}</p>
    </div>
    <!--      <div>-->
    <!--        <pre>{{ JSON.stringify($auth.user, null, 2) }}</pre>-->
    <!--      </div>-->
    <!-- show login when not authenticated -->
    <div class="nda" v-if="isNdaRejected">
      <p>
        You cannot access the Virtual Vault without accepting the NDA. Please refresh your browser to continue.
      </p>
    </div>
    <div class="nda" v-if="!!user.user && !user.hasSignedNda && !isNdaRejected">
      <p>
        A signed Non-Disclosure Agreement is a requirement to access the Virtual Vault. All information and images within the Vault are restricted and
        are solely for the purposes of the work you are tasked with completing regarding new member and supplemental applications. To ensure the
        privacy of all members, please adhere to the details of your agreement with GSMD and the NDA. Any violation will result in a lifetime ban of
        access to this data.
      </p>
      <div class="nda-buttons">
        <v-btn @click="ndaReject">Exit</v-btn>
        <v-btn class="nda-accept" color="secondary" @click="ndaAccept">I Agree</v-btn>
      </div>
    </div>
    <v-btn color="secondary" v-if="!user.user" @click="login">Log in</v-btn>
    <!-- show logout when authenticated -->
    <v-btn v-if="!!user.user" @click="logout">Log out</v-btn>
  </v-container>
</template>

<script>
import store from "@/store";
import Auth from "@/services/Auth";
import { mapState } from "vuex";

export default {
  name: "Home",
  data: function() {
    return {
      isNdaRejected: false
    };
  },
  computed: mapState(["user"]),
  methods: {
    // Log the user in
    login() {
      Auth.login();
    },
    // Log the user out
    logout() {
      Auth.logout();
    },
    ndaReject() {
      this.isNdaRejected = true;
    },
    ndaAccept() {
      store.dispatch("userSignNda", true);
    }
  }
};
</script>
<style scoped>
.nda {
  margin-left: 20%;
  margin-right: 20%;
  border: 10px grey solid;
  padding: 20px;
}
.nda-buttons {
  display: flex;
  justify-content: space-around;
}
</style>
